import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const temas = [
  { titulo: "Tema 1: Introducción", to: "/python/tema-1", material: "doc/Material_complementario_tema_1.docx" },
  { titulo: "Tema 2: Primeros Conceptos", to: "/python/tema-2", material: "doc/Material_complementario_tema_2.docx" },
  { titulo: "Tema 3: Programación Básica", to: "/python/tema-3", material: "doc/Material_complementario_tema_3.docx" },
  { titulo: "Tema 4: Funciones", to: "/python/tema-4", material: "doc/Material_complementario_tema_4.docx" },
  { titulo: "Tema 5: Organización de Código", to: "/python/tema-5", material: "doc/Material_complementario_tema_5.docx" },
  { titulo: "Tema 6: Aspectos Avanzados", to: "/python/tema-6", material: "doc/Material_complementario_tema_6.docx" },
  { titulo: "Tema 7: Análisis de Datos", to: "/python/tema-7", material: "doc/Material_complementario_tema_7.docx" },
  { titulo: "Tema 8: Visualización de Datos", to: "/python/tema-8", material: "doc/Material_complementario_tema_8.docx" },
];

const Python = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Curso de Python</h1>
        </div>
        <div className="orgproc-grid-4col">
          {temas.map((tema, index) => (
            <div className="orgproc-card" key={tema.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Tema #{index + 1}</div>
                <div className="orgproc-card-title">{tema.titulo}</div>
                <div className="orgproc-card-actions">
                  <Link className="orgproc-card-btn" to={tema.to}>
                    Ver PDF →
                  </Link>
                  <a
                    className="orgproc-card-btn"
                    href={`${bucketUrl}/${tema.material}`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Material →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default Python;